class LanguageSwitcher extends HTMLElement {
  connectedCallback() {
    this.form = this.closest("form");
    this.buttons = this.querySelectorAll(".language-switcher__option");

    if (!this.form || !this.buttons.length) return;

    this.buttons.forEach((button) => {
      button.addEventListener("click", (event) => {
        if (button.classList.contains("active")) {
          event.preventDefault();
        }
      });
    });
  }
}

customElements.define("language-switcher", LanguageSwitcher);
